module.exports = __webpack_public_path__ + "static/media/edited6.3acb9bd2.png";